import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
// import ReactDOM from "react-dom";
import { extendTheme, ChakraProvider } from "@chakra-ui/react";
import "./index.css";
// import reportWebVitals from "./reportWebVitals";
// import App from "./App";
const App = React.lazy(() => import("./App"));

const theme = extendTheme({
  config: {
    initialColorMode: "dark",
    useSystemColorMode: false,
  },
  colors: {
    teal: {
      50: "#ace6e2", // was 200
      100: "#81d6d0", // was 300
      200: "#36b5aa", // was 400
      300: "#009688", // was 500
      400: "#008773", // was 600
      500: "#007058", // was 700
      600: "#005940", // was 800
      700: "#00452d", // was 900
      800: "#00371f", // newly added: very dark teal-green
      900: "#002418", // newly added: near-black green
    },
  },
  semanticTokens: {
    colors: {
      "chakra-body-bg": {
        _light: "#f5f5f5",
        _dark: "#1a202c",
      },
      "chakra-text-color": {
        _light: "#1a202c",
        _dark: "#ffffff",
      },
    },
  },
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <Suspense
        fallback={
          <div>
            <div className="loading-topbar mobile-only">Welcome!</div>
            <div className="loading-topbar desktop-only">
              Welcome to CrissWord
            </div>

            <div className="loading-body">
              <p>
                CrissWord is essentially a{" "}
                <strong>2-clue mini crossword</strong> where there are multiple
                common letters in the answers. Clues can either be synonyms of
                the answer or wordplay, sometimes based on general knowledge.
              </p>

              <p
                style={{
                  marginTop: 24,
                }}
              >
                There are <strong>new puzzles every day</strong> but if you want
                to try more, use the drop-down menu in the top right to view the
                last 5 days.
              </p>

              <p
                style={{
                  marginTop: 24,
                }}
              >
                Have a read through the tutorial, then start playing and sharing
                your results.
              </p>
            </div>
          </div>
        }
      >
        <App />
      </Suspense>
    </ChakraProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
